import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules, Router, NavigationStart, NavigationEnd, NavigationError } from '@angular/router';

import { FullLayoutComponent } from './layouts/full/full-layout.component';
import { ContentLayoutComponent } from './layouts/content/content-layout.component';

import { FULL_ROUTES } from './shared/routes/full-layout.routes';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';

import { AuthGuard } from './shared/auth/auth-guard.service';
import { LogService } from './shared/services/log.service';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: { title: 'full Views' },
    children: FULL_ROUTES,
    canActivate: [AuthGuard]
  },
  {
    path: '',
    component: ContentLayoutComponent,
    data: { title: 'content Views' },
    children: CONTENT_ROUTES
  },
  {
    path: '**',
    redirectTo: 'error'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})

export class AppRoutingModule {

  constructor(private router: Router, private log: LogService) {
    this.router.events.subscribe((event: any) => {
      // ✅ FILTRO CORRECTO: Solo registra cuando realmente inicia una navegación
      if (event instanceof NavigationStart) {
        this.log.setName('** URL Changed');
        // Ahora veremos exactamente a qué URL intenta ir y por qué (imperative, popstate, etc.)
        this.log.debug('Navegando a: ', event.url, ' | Trigger: ', event.navigationTrigger);
        console.warn('🔄 NAVEGACIÓN DETECTADA -> URL:', event.url, '| Causa:', event.navigationTrigger);

      }
    });
  }
}
